function openQuickView(handle) {
const modal = document.getElementById('QuickViewModal');
const content = document.getElementById('QuickViewContent');

// Show the modal
modal.style.display = 'flex';

// Fetch product content via AJAX
fetch(`/products/${handle}?view=quick-view`)
    .then(response => response.text())
    .then(html => {
    content.innerHTML = html;
    });
}

function closeQuickView() {
const modal = document.getElementById('QuickViewModal');
modal.style.display = 'none';
}





// Discounted Form State Logic
(function () {
  var CA = ['Alberta','British Columbia','Manitoba','New Brunswick',
    'Newfoundland and Labrador','Northwest Territories','Nova Scotia',
    'Nunavut','Ontario','Prince Edward Island','Quebec','Saskatchewan','Yukon'];

  function getRoot() {
    var host = Array.from(document.querySelectorAll('*')).find(function (e) {
      return e.shadowRoot && e.shadowRoot.querySelector('[data-form-root]');
    });
    return host ? host.shadowRoot : null;
  }

  function apply(root) {
    var list = root.getElementById('custom#state-selector-dropdown');
    var val = root.getElementById('custom#country-selector-value');
    if (!list || !val) return;
    var isCA = /canada/i.test(val.textContent);
    list.querySelectorAll('[role="option"]').forEach(function (o) {
      var inCA = CA.indexOf(o.textContent.trim()) !== -1;
      var d = (inCA === isCA) ? '' : 'none';
      var w = o.parentElement;
      if (w.style.display !== d) w.style.display = d;
    });
  }

  function init() {
    var root = getRoot();
    if (!root) return false;
    new MutationObserver(function () { apply(root); })
      .observe(root, { childList: true, subtree: true });
    apply(root);
    return true;
  }

  var tries = 0;
  var t = setInterval(function () {
    if (init() || ++tries > 40) clearInterval(t);
  }, 250);
})();




(function () {
  function fix() {
    var host = Array.from(document.querySelectorAll('*')).find(function (e) {
      return e.shadowRoot && e.shadowRoot.querySelector('[data-form-root]');
    });
    if (!host) return false;
    if (host.shadowRoot.querySelector('#custom-width')) return true;
    var s = document.createElement('style');
    s.id = 'custom-width';
    s.textContent = '[class*="_formContainer_"] { max-width: 700px !important; }';
    host.shadowRoot.appendChild(s);
    return true;
  }
  var tries = 0;
  var t = setInterval(function () {
    if (fix() || ++tries > 40) clearInterval(t);
  }, 250);
})();